var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dzs-form-item"},[_c('el-form-item',{attrs:{"label":_vm.item.label,"prop":_vm.item.key}},[_vm._t(`${_vm.item.key}Before`),(_vm.item.props && _vm.item.props.isSlot)?[_vm._t(`${_vm.item.key}`)]:_vm._t("default"),_vm._t(`${_vm.item.key}After`)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }